var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('two-column-layout',{class:_vm.rootClass},[_c('pogs-list-cases',{attrs:{"slot":"sidebar","patientcases":_vm.patientcases,"patientCount":_vm.computedPatientCount},on:{"hideNav":_vm.hideNav},slot:"sidebar"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }